import React, { useEffect, useState } from 'react';
import './GalleryPage.css';
import GalleryCard from '../../Components/GalleryCard/GalleryCard';
import Gimg1 from "../../Assets/missanHome.avif";
import Gimg3 from "../../Assets/trendlineeg.avif";
import Gimg4 from "../../Assets/lawyer.avif";
import Gimg5 from "../../Assets/premium.avif";
import Gimg6 from "../../Assets/hamasat.avif";
import Gimg7 from "../../Assets/entity.avif";
import Gimg8 from "../../Assets/rams.avif";
import Gimg9 from "../../Assets/weavr.avif";
import NavPage from '../../Components/NavPage/NavPage';
import Loading from '../../Components/loading/Loading';
import FooterEnds from '../../Components/FooterEnds/FooterEnds';
import { Helmet, HelmetProvider } from 'react-helmet-async';

const data1 = [
    {
        id: 1,
        image: Gimg1,
        month: "June",
        year: "2024",
        title: 'Missan Al-Mahariya',
        desc: "Programming company providing creative and diverse technical services.",
        link: 'https://missanvip.com/'
    },
    {
        id: 2,
        image: Gimg3,
        month: "July",
        year: "2024",
        title: 'TrendLine E-Commerce',
        desc: "Providing expert consultation, design, installation, and maintenance services for all your technological and security needs.",
        link: 'https://trendlineeg.com/'
    },
    {
        id: 3,
        image: Gimg4,
        month: "April",
        year: "2024",
        title: 'Lawyer Website',
        desc: "Law and Legal Consulting Company provides legal services with local and international dealings with basic vision and value.",
        link: 'https://flata.missanvip.com/'
    },
    {
        id: 4,
        image: Gimg8,
        month: "January",
        year: "2024",
        title: 'Ramis Hotel',
        desc: "UI design for a hotel website providing addresses, services, and reservation capabilities.",
        link: 'https://www.behance.net/gallery/205281559/Ramis-Hotel'
    },
    {
        id: 5,
        image: Gimg5,
        month: "November",
        year: "2023",
        title: 'Premium Agency',
        desc: "A creative agency providing graphic designs and video editing services.",
        link: 'https://mo-metwally.github.io/premium-agency.github.io/'
    },
    {
        id: 6,
        image: Gimg9,
        month: "December",
        year: "2023",
        title: 'EDU Weaver',
        desc: "The platform is user-friendly and well-designed, with intuitive navigation and visually appealing layouts that make learning enjoyable.",
        link: 'https://www.behance.net/gallery/205282019/EDU-Weaver'
    },
    {
        id: 7,
        image: Gimg6,
        month: "March",
        year: "2023",
        title: 'Hamasat Home',
        desc: "E-commerce website offering a unique and modern assortment of kitchenware.",
        link: 'https://mo-metwally.github.io/Hamasat-ecomm/'
    },
    {
        id: 8,
        image: Gimg7,
        month: "July",
        year: "2022",
        title: 'Entity Agency',
        desc: "It is my Graduation project.",
        link: 'https://mo-metwally.github.io/Entity-Agency.github.io/index.html'
    },
];

const GalleryPage = () => {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        // Scroll to the top of the page when the component mounts
        window.scrollTo(0, 0);

        // Simulate loading delay (e.g., 1 second), replace with actual loading logic
        setTimeout(() => {
            setIsLoading(false);
        }, 4000);
    }, []);

    if (isLoading) {
        return (
            <Loading />
        );
    }

    return (
        <>
            <HelmetProvider>
                <Helmet>
                    <title>M.Metwally's Work's Gallery</title>
                    <link rel="canonical" href="https://mohammed-metwally.web.app/Gallery" />
                    <meta name="description" content="Here You Can See All Of My Work. Discover the innovative work of Mohamed Metwally, where innovation meets expertise in front-end web development. Dive into a showcase of dynamic, responsive web applications crafted with React.js, GSAP, and Tailwind CSS. Explore Mohamed’s diverse projects that highlight his commitment to creating seamless, user-centric experiences. Whether you’re looking for inspiration, interested in collaboration, or seeking top-tier web solutions, this site offers a comprehensive look at Mohamed’s skills and achievements. Discover how his passion for technology and design can bring your ideas to life, and find the contact information to start your next project. Explore, connect, and see how Mohamed can elevate your digital presence." />
                </Helmet>
            </HelmetProvider>

            <div className='GalleryPage' id='GPage'>
                <div className='blur2'>
                    <div className="fake2"></div>
                    <div id='PageHL'>
                        <h2>Welcome To My Gallery</h2>
                        <h5>My Recent Work</h5>
                    </div>
                </div>
                <NavPage />
                <div className='protoflio__container'
                >
                    {
                        data1.map(({ id, image, month, year, title, desc, link }) => (
                            <GalleryCard
                                key={id}
                                id={id}
                                image={image}
                                month={month}
                                year={year}
                                title={title}
                                desc={desc}
                                link={link}
                            />
                        ))
                    }
                </div>
            </div>
            <FooterEnds />
        </>
    );
}

export default GalleryPage;
